import { render, staticRenderFns } from "./GeneralInformation.vue?vue&type=template&id=b0e2657c&scoped=true"
import script from "./GeneralInformation.vue?vue&type=script&lang=js"
export * from "./GeneralInformation.vue?vue&type=script&lang=js"
import style0 from "./GeneralInformation.vue?vue&type=style&index=0&id=b0e2657c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e2657c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0e2657c')) {
      api.createRecord('b0e2657c', component.options)
    } else {
      api.reload('b0e2657c', component.options)
    }
    module.hot.accept("./GeneralInformation.vue?vue&type=template&id=b0e2657c&scoped=true", function () {
      api.rerender('b0e2657c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/proposalProcess/components/GeneralInformation.vue"
export default component.exports